import * as React from 'react';
import {useState} from 'react';
import PropTypes from "prop-types";
import classnames from "classnames";
import apiUser from "../../../apiUser";
import Button from "../../Button";
import {
  Alert,
  ButtonGroup,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row
} from "reactstrap";
import moment from "moment";
import DateRangePicker from "../../DateRangePicker";
import {toast} from "react-toastify";
import {SUPPLIERS_LIST} from "../SupplierTypeSelect";
import {connect, useDispatch} from "react-redux";
import SynchronizedInfo from "./SynchronizedInfo";
import PlanFeatureDisabled from "../../PlanFeatureDisabled";
import Icon from "../../../componentsReusable/Icon";
import SupplierCreateIntegration from "../SupplierCreate/SupplierCreateIntegration";
import Link from "../../Application/Link";
import appUserRoutes from "../../../appUserRoutes";
import SupplierEditModal from "../SupplierEditModal";
import isWorker from "../../../utils/isWorker";
import {hideModal} from "./reducer/ModalActions";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";
import {updateSupplier} from "../../../reducers/suppliers/actions";
import {useTranslation} from "react-i18next";
import {
  SUPPLIER_TYPE_ABAK_MOTO,
  SUPPLIER_TYPE_AUTO_CENTRUM_MATUSIEWICZ,
  SUPPLIER_TYPE_MOTO_ART_KIELCE,
  SUPPLIER_TYPE_MOTO_ART_WLOSZCZOWA,
  SUPPLIER_TYPE_POLAMEL,
  SUPPLIER_TYPE_SIEMIENIEC,
  SUPPLIER_TYPE_TD_AUTO_KEDZIERZYN,
  SUPPLIER_TYPE_TD_AUTO_OPOLE
} from "../SupplierTypes";
import TextWithTooltip from "../../../componentsReusable/TextWithTooltip";

const SuppliersModal = props => {
  const { t } = useTranslation('suppliers_modal')
  const dispatch = useDispatch()
  const [supplierEditing, setSupplierEditing] = useState(null)
  const [dateFrom, setDateFrom] = React.useState(moment().format('YYYY-MM-DD'));
  const [dateTo, setDateTo] = React.useState(moment().format('YYYY-MM-DD'));
  const [synchronizing, setSynchronizing] = React.useState(false);
  const [synchronized, setSynchronized] = React.useState([]);
  const [supplier, setSupplier] = React.useState(props.supplier);
  const [dateRange, setDateRange] = useState('today')

  useAfterUpdateEffect(() => {
    switch (dateRange) {
      case 'today': {
        setDateFrom(moment().format('YYYY-MM-DD'))
        setDateTo(moment().format('YYYY-MM-DD'))
        break;
      }
      case 'yesterday': {
        setDateFrom(moment().subtract(1, 'days').format('YYYY-MM-DD'))
        setDateTo(moment().subtract(1, 'days').format('YYYY-MM-DD'))
        break;
      }
      case '-3 days': {
        setDateFrom(moment().subtract(2, 'days').format('YYYY-MM-DD'))
        setDateTo(moment().format('YYYY-MM-DD'))
        break;
      }
      case '-7 days': {
        setDateFrom(moment().subtract(6, 'days').format('YYYY-MM-DD'))
        setDateTo(moment().format('YYYY-MM-DD'))
        break;
      }
      case 'custom': {
        setDateFrom(moment().format('YYYY-MM-DD'))
        setDateTo(moment().format('YYYY-MM-DD'))
        break;
      }
    }
  }, [dateRange])

  if(!props.isOpen){
    return null
  }

  const closeModal = () => dispatch(hideModal())

  const getSuppliersCorrect = () => {
    return props.suppliers.filter(supplier => supplier.correct)
  }

  const getSuppliersIncorrect = () => {
    return props.suppliers.filter(supplier => !supplier.correct)
  }

  const synchro = async() => {
    setSynchronizing(true);

    const _synchro = (from, to) => {
      if(moment(to) > moment(dateTo)){
        to = dateTo;
      }

      const key = [from, to].join(' - ');

      setSynchronized(synchronized => ([
        ...synchronized,
        {
          key,
        }
      ]))

      apiUser.suppliers.documentSynchro(supplier.id, {
        dateFrom: from,
        dateTo: to
      })
        .then(res => {
          if(res.supplier){
            dispatch(updateSupplier(res.supplier))
          }

          setSynchronized(synchronized => synchronized.map(synch => {
              if(synch.key === key){
                synch.result = res.synchronize
              }

              return synch;
            })
          )
        })
        .finally(res => {
          setSynchronized(synchronized => synchronized.map(synch => {
              if(synch.key === key){
                synch.completed = true
              }

              return synch;
            })
          )

          if(from !== to && to !== dateTo){
            _synchro(moment(to).add(1, 'days').format('YYYY-MM-DD'), moment(to).add(7, 'days').format('YYYY-MM-DD'))
          }else{
            setSynchronizing(false);
            toast.success('Import dokumentów przebiegł poprawnie')
          }
        })
    }
    _synchro(dateFrom, moment(dateFrom).add(6, 'days').format('YYYY-MM-DD'));
  }

  return <Modal isOpen scrollable size="lg">
    <ModalHeader toggle={!synchronizing && closeModal}>
      <span>{t('header')}</span>
    </ModalHeader>
    <hr className="my-0"/>
    <ModalBody>
      {
        props.workshop.workshopPlan.currentPlanSettings.warehouseImports
          ? <React.Fragment>
            <SynchronizedInfo synchronized={synchronized} />

            {synchronized.length > 0 && !synchronizing && <Button color={'secondary'} size={'sm'} onClick={() => setSynchronized([])}><i className="fas fa-arrow-left"/><span>Wróć</span></Button>}

            {(!synchronizing && synchronized.length === 0) && <React.Fragment>
              <Card>
                <CardHeader className="d-flex align-items-center justify-content-between flex-nowrap">
                  <span>{t('integrations_correct.header')}</span>

                  <Link to={appUserRoutes.settings.suppliers.list} onClick={() => closeModal()}><Icon className="fas fa-cog" tooltip={t('integrations_correct.btn_settings')} /></Link>
                </CardHeader>
                <CardBody>
                  {getSuppliersCorrect().length === 0 && <Alert color="warning" className="mb-0 text-center">
                    {t('integrations_correct.no_suppliers')}
                  </Alert>}
                  <Row className="supplier-img-list">
                    {getSuppliersCorrect().map((_supplier, key) => <Col key={key} className="mb-3" xs={6} sm={4} md={3} onClick={() => setSupplier(_supplier)}>
                      <div className={classnames({
                        'supplier rounded pt-3 px-1 cursor-pointer border': true,
                        'selected border-primary': _supplier.id === supplier?.id,
                      })}>
                        <img
                          className="mx-auto d-block logo-img grayscale"
                          src={SUPPLIERS_LIST.find(st => st.value === _supplier.type).logo}
                          style={{maxHeight: '45px'}}
                        />
                        <div className="d-flex flex-row flex-nowrap justify-content-between align-items-center mt-2">
                          <small className="text-secondary">
                            <Icon className="fas fa-clock mr-2" tooltip={t('integrations_correct.last_synchro_tooltip')}/>
                            {_supplier.documentsLastSynchroDate ? moment(_supplier.documentsLastSynchroDate).fromNow() : <i>{t('integrations_correct.last_synchro_none')}</i>}
                          </small>
                          <TextWithTooltip tooltip={t('integrations_correct.supplier_identification')}><small className="text-secondary text-right">{_supplier.supplierIdentification}</small></TextWithTooltip>
                        </div>
                      </div>
                    </Col>)}
                  </Row>
                  {supplier && (
                    [
                      SUPPLIER_TYPE_SIEMIENIEC,
                      SUPPLIER_TYPE_ABAK_MOTO,
                      SUPPLIER_TYPE_AUTO_CENTRUM_MATUSIEWICZ,
                      SUPPLIER_TYPE_MOTO_ART_WLOSZCZOWA,
                      SUPPLIER_TYPE_MOTO_ART_KIELCE,
                      SUPPLIER_TYPE_POLAMEL,
                      SUPPLIER_TYPE_TD_AUTO_KEDZIERZYN,
                      SUPPLIER_TYPE_TD_AUTO_OPOLE,
                    ].includes(supplier.type) && <Alert color="info" className="mb-0">{t('integrations_correct.supplier_selected.profiBiznes.alert')}</Alert>
                  )}
                  {supplier && <ButtonGroup className="mt-3 d-flex flex-column flex-sm-row">
                    <Button color={dateRange === 'today' ? 'primary' : 'light'} onClick={() => setDateRange('today')}>{t('integrations_correct.btn.date_range_today')}</Button>
                    <Button color={dateRange === 'yesterday' ? 'primary' : 'light'} onClick={() => setDateRange('yesterday')}>{t('integrations_correct.btn.date_range_yesterday')}</Button>
                    <Button color={dateRange === '-3 days' ? 'primary' : 'light'} onClick={() => setDateRange('-3 days')}>{t('integrations_correct.btn.date_range_last_x_days', {days: 3})}</Button>
                    <Button color={dateRange === '-7 days' ? 'primary' : 'light'} onClick={() => setDateRange('-7 days')}>{t('integrations_correct.btn.date_range_last_x_days', {days: 7})}</Button>
                    <Button color={dateRange === 'custom' ? 'primary' : 'light'} onClick={() => setDateRange('custom')}>{t('integrations_correct.btn.date_range_select')}</Button>
                  </ButtonGroup>}
                  {dateRange === 'custom' && <div className="mt-2">
                    <span className="mr-2">{t('integrations_correct.date_range_select')}</span>
                    <DateRangePicker
                      showClearDates={false}
                      dateFrom={moment(dateFrom)}
                      dateTo={moment(dateTo)}
                      onDatesChange={({startDate, endDate}) => {
                        if (endDate < startDate) {
                          endDate = startDate
                        }
                        setDateFrom(startDate?.format('YYYY-MM-DD') || null);
                        setDateTo(endDate?.format('YYYY-MM-DD') || null);
                      }}
                    />
                  </div>}
                </CardBody>
                <CardFooter className="py-1">
                  {(!synchronizing && synchronized.length === 0) && <Button
                    className="ml-auto"
                    loading={synchronizing}
                    disabled={!supplier || !dateFrom || !dateTo}
                    onClick={synchro}
                  ><i className="fas fa-file-download"/><span className="ml-2">{t('integrations_correct.btn.synchro')}</span></Button>}
                </CardFooter>
              </Card>

              {!isWorker() && <React.Fragment>
                {getSuppliersIncorrect().length > 0 && <Card>
                  <CardHeader>{t('integrations_in_progress.header')}</CardHeader>
                  <CardBody className="pb-0">
                    <Alert color={'warning'}>{t('integrations_in_progress.alert_text')}</Alert>
                    <Row className="supplier-img-list">
                      {getSuppliersIncorrect().map((supplier, key) => <Col key={key} className="mb-3" xs={6} sm={4} md={3} onClick={() => setSupplierEditing(supplier)}>
                        <div className="supplier rounded py-3 px-1 cursor-pointer border">
                          <img
                            className="mx-auto d-block logo-img grayscale"
                            src={SUPPLIERS_LIST.find(st => st.value === supplier.type).logo}
                            style={{maxHeight: '45px'}}
                          />
                        </div>
                      </Col>)}
                    </Row>
                    {supplierEditing && <SupplierEditModal
                      supplier={supplierEditing}
                      onClose={() => setSupplierEditing(null)}
                    />}
                  </CardBody>
                </Card>}

                <Card>
                  <CardHeader>{t('integrations_create.header')}</CardHeader>
                  <CardBody className="pb-0">
                    <SupplierCreateIntegration

                    />
                  </CardBody>
                </Card>
              </React.Fragment>}
            </React.Fragment>}
          </React.Fragment>
          : <PlanFeatureDisabled />
      }
    </ModalBody>
    <ModalFooter>
      {!synchronizing && <Button color="secondary" className="mb-0" onClick={() => closeModal()}>{t('common:btn.close')}</Button>}
    </ModalFooter>
  </Modal>
}

const SuppliersModalWrapper = props => {
  if(!props.isOpen){
    return null
  }

  return <SuppliersModal {...props} />
}

SuppliersModalWrapper.propTypes = {
  supplier: PropTypes.shape({
    id: PropTypes.number.isRequired,
    documentsLastSynchroDate: PropTypes.string,
    supplierIdentification: PropTypes.string
  }),
};

function mapStateToProps(state) {
  return {
    isOpen: state.suppliersContainer.isOpen,
    suppliers: state.suppliers,
    workshop: state.workshop,
  }
}

export default connect(mapStateToProps)(SuppliersModalWrapper);
